import { Instance, types } from 'mobx-state-tree'

export const ErrorModel = types.model('ErrorModel', {
  name: types.string,
  message: types.string,
})

enum OperationStatusEnum {
  NotStarted = 'Not Started',
  InProgress = 'In Progress',
  Success = 'Success',
  Failure = 'Failure',
}

export const OperationStatusModel = types
  .model('OperationStatusModel')
  .props({
    _status: types.enumeration('OperationStatusEnum', [...Object.values(OperationStatusEnum)]),
    error: types.maybe(ErrorModel),
  })
  .views((self) => ({
    get inProgress(): boolean {
      return self._status === OperationStatusEnum.InProgress
    },
    get isSuccess(): boolean {
      return self._status === OperationStatusEnum.Success
    },
    get isStarted(): boolean {
      return self._status !== OperationStatusEnum.NotStarted
    },
    get isFailure(): boolean {
      return self._status === OperationStatusEnum.Failure
    }
  }))

export const OperationNotStarted = () => OperationStatusModel.create({ _status: OperationStatusEnum.NotStarted })
export const OperationInProgress = () => OperationStatusModel.create({ _status: OperationStatusEnum.InProgress })
export const OperationSuccess = () => OperationStatusModel.create({ _status: OperationStatusEnum.Success })
export const OperationFailure = (error: Error) => {
  // Destructuring error explicitly since its properties are not enumerable - https://stackoverflow.com/a/59874261/4574731
  const { name, message } = error
  return OperationStatusModel.create({ _status: OperationStatusEnum.Failure, error: { name, message } })
}

export type OperationStatus = Instance<typeof OperationStatusModel>


export function combinedOperationStatus(...statuses: OperationStatus[]) {
  // If there's any failed status - the combined result is error
  const failedOperation = statuses.find(status => status.error)
  if (failedOperation !== undefined) {
    return failedOperation
  } 

  if (statuses.some(status => status.inProgress)) {
    return OperationInProgress()
  }

  if (statuses.some(status => !status.isStarted)) {
    return OperationNotStarted()
  }

  return OperationSuccess()
}